import { render, staticRenderFns } from "./ErResponsesIcon.vue?vue&type=template&id=688b4fd8"
import script from "./ErResponsesIcon.vue?vue&type=script&lang=js"
export * from "./ErResponsesIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports